import React from "react"
import { ColLeft, ColRight } from "../App.styles"
import {
  AntecipationCell,
  BoletoCell,
  DocumentUploadCell,
  DonateLinkCell,
  DonateStatusCell,
  FormAccountCell,
  QrCell,
} from "../cells"
export function ConfigPage() {
  return (
    <>
      <ColLeft>
        <FormAccountCell />
        <DocumentUploadCell />
      </ColLeft>
      <ColRight>
        <DonateStatusCell />

        <DonateLinkCell />

        <QrCell />

        <AntecipationCell />

        <BoletoCell />
      </ColRight>
    </>
  )
}
